module.exports = __webpack_public_path__ + "static/media/item05.3f157376.png";